import * as React from 'react';
import * as $ from 'jquery';

import * as reactGlobalClick from './reactGlobalClick';

export interface IDraggableItem {
    itemType: string;
    itemId?: number;
    name?: string;
    id?: number;
}

export interface IDraggableItemData {
    scope: string;
    itemType?: string;
}

export function handleMenuItemDragging(e, ui) {
    const triggerZone = 20;
    const scrollSpeed = 10;

    $('.menu-tree').each(function () {
        var $this = $(this);
        var cOffset = $this.offset();
        var bottomPos = cOffset.top + $this.height();

        if (e.pageY >= bottomPos - triggerZone && e.pageY <= bottomPos) {
            $this.scrollTop($this.scrollTop() + scrollSpeed);
        }
        if (e.pageY >= cOffset.top && e.pageY <= cOffset.top + triggerZone) {
            $this.scrollTop($this.scrollTop() - scrollSpeed);
        }
    });
}

export function useDraggableHook(
    draggableElement: React.MutableRefObject<HTMLDivElement>,
    scope: string,
    appendTo: string,
    payload: IDraggableItem,
    zIndex: number
) {
    React.useEffect(() => {
        const element = $(draggableElement.current);

        element
            .draggable({
                helper: () => {
                    const clone = element.clone();

                    clone.removeAttr('data-reactid');

                    clone.find('*').each(function () {
                        $(this).removeAttr('data-reactid');
                    });

                    return clone;
                },

                revert: true,
                revertDuration: 0,
                zIndex: zIndex,
                addClasses: false,
                appendTo: $(appendTo),
                scope: scope,
                start: (e, ui) => {
                    reactGlobalClick.setDoNotProcessFlag(true);
                    element.addClass('dragging');
                },
                stop: (e, ui) => {
                    element.removeClass('dragging');
                    reactGlobalClick.setDoNotProcessFlag(false);
                },
                drag: (e, ui) => {
                    //scrollToPositionWhileDragging('.fields-toolbar', e);
                }
            })
            .data('payload', payload);

        return () => {
            element.draggable('destroy');
            reactGlobalClick.setDoNotProcessFlag(false);
        };
    }, [scope, appendTo, zIndex]);
}

export function useDropableHook(
    dropableElement: React.MutableRefObject<HTMLDivElement>,
    scope: string,
    onDrop: (e, ui) => void
) {
    React.useEffect(() => {
        const element = $(dropableElement.current);

        element.droppable({
            hoverClass: 'hover',
            activeClass: 'active',
            tolerance: 'pointer',
            scope: scope,
            drop: onDrop
            //over: handleOver,
        });

        return () => {
            element.droppable('destroy');
        };
    }, [scope, onDrop]);
}

export function useElementsReorderingHook(
    container: React.MutableRefObject<HTMLElement>,
    options: {
        axis: 'x' | 'y';
        sortableItems: string;
        handle?: string;
        disable?: boolean;
    },
    onChange: (start: number, stop: number) => void,
    deps: React.DependencyList = []
) {
    const startIndex = React.useRef<number>(null);

    React.useEffect(() => {
        if (!options.disable) {
            const reorderStart = (e, ui) => {
                reactGlobalClick.setDoNotProcessFlag(true);
                startIndex.current = $(ui.item).index();
            };

            const reorderStop = (e, ui) => {
                reactGlobalClick.setDoNotProcessFlag(false);

                const start = startIndex.current;

                if (start == null) {
                    return;
                }

                const stop = $(ui.item).index();

                startIndex.current = null;
                $(container.current).sortable('cancel');

                if (start !== stop) {
                    onChange(start, stop);
                }
            };

            $(container.current).sortable({
                axis: options.axis,
                items: options.sortableItems,
                handle: options.handle,
                forceHelperSize: true,
                opacity: 0.8,
                cursor: 'grabbing',

                start: reorderStart,
                stop: reorderStop
            });
        }

        return () => {
            if (!options.disable) {
                const tabs = container.current;

                if (tabs != null) {
                    $(tabs).sortable('destroy');
                }

                reactGlobalClick.setDoNotProcessFlag(false);
            }
        };
    }, deps);
}
